import { LinkContainer } from 'react-router-bootstrap';
import { Button } from 'react-bootstrap';
import { DiscordWidget } from '../components/DiscordWidget';
import { GameFeatures } from '../components/GameFeatures/GameFeatures';
import { Video } from '../components/Video';
import './Home.css';

function Home() {
  return (
    <div>
      <div className="home-cta">
        <p className="home-cta-tagline">A free, custom Conquer Online private server.</p>
        <div className="home-cta-buttons">
          <LinkContainer to="/register">
            <Button className="home-cta-btn home-cta-btn--primary">Create Account</Button>
          </LinkContainer>
          <LinkContainer to="/download">
            <Button className="home-cta-btn home-cta-btn--secondary">Download Game</Button>
          </LinkContainer>
        </div>
      </div>
      <GameFeatures />
      <Video />
      <DiscordWidget />
    </div>
  );
}

export { Home };
